import * as React from 'react'
import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'
import { useAppSelector } from '../../store/appHooks'

export default function GlobalBackDrop() {
  const { globalReducer }: any = useAppSelector((state) => state)
  const { backdropConfig } = globalReducer

  return (
    <div>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropConfig?.open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  )
}
